export function debounce(fn, delay = 300, name = "debouncedFn") {
  if (typeof fn !== "function") {
    console.warn(`[${name}] Expected a function, got ${typeof fn}`);
    return;
  }

  let timer;
  let callCount = 0;
  let cancelCount = 0;
  let executeCount = 0;

  return function (...args) {
    callCount++;

    if (timer) {
      cancelCount++;
      console.debug(`[${name}] Previous call canceled. Timer ID: ${timer}, Delay: ${delay}ms`);
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      executeCount++;
      console.debug(`[${name}] Executing function. Total calls: ${callCount}, Canceled: ${cancelCount}, Executed: ${executeCount}`);
      fn.apply(this, args);
      timer = null;
    }, delay);
  };
}
